export default {"src":"/_next/static/media/money-back-guarantee.14545d6a.svg","height":127,"width":129,"blurWidth":0,"blurHeight":0};